import { createRouter as createTanStackRouter } from "@tanstack/react-router";
import { ErrorComponent } from "@/components/Error";
import { NotFound } from "@/components/NotFound";
import { routeTree } from "@/routeTree.gen";

export function createRouter() {
  const router = createTanStackRouter({
    routeTree,
    defaultErrorComponent: (props) => (
      <ErrorComponent
        title="Oops! Something went wrong"
        message="We encountered an unexpected error"
        backTo={{
          path: "/",
          text: "Back to dashboard",
        }}
        {...props}
      />
    ),
    defaultNotFoundComponent: NotFound,
    context: {
      auth: undefined,
    },
  });

  return router;
}
declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}
